// Module
var code = `<div id="file-upload-new" ng-form name="\$ctrl.uploadForm">
  <div class="file-upload-new__container" >
    <div name="uploadFile"
         ng-model="\$ctrl.dropZoneUpload"
         ngf-drop="\$ctrl.addFiles(\$files)"
         ng-disabled="\$ctrl.ngDisabled"
         ngf-multiple="\$ctrl.multiple"
         class="file-upload-new__drop-zone"
         ngf-validate="\$ctrl.resolvedValidate"
         ngf-model-invalid="\$ctrl.invalidFiles"
    >
      Drop file
    </div>
    <button type="button"
            name="uploadFile"
            ng-model="\$ctrl.selectFileUpload"
            ngf-select="\$ctrl.addFiles(\$files)"
            class="btn btn-warning"
            ngf-validate="\$ctrl.resolvedValidate"
            ng-disabled="\$ctrl.ngDisabled"
            ngf-model-invalid="\$ctrl.invalidFiles"
    >
        Select file
    </button>
    <button class="btn btn-info"
            type="button"
            ng-if="\$ctrl.enableWebcam"
            ng-click="\$ctrl.showWebcam(\$event)"
            ng-disabled="\$ctrl.ngDisabled">
        Take photo
    </button>
  </div>
  <div class="alert alert--danger" ng-if="\$ctrl.uploadForm.\$dirty && (\$ctrl.invalidFiles.\$error === 'maxSize' || \$ctrl.invalidFiles[0].\$error === 'maxSize')">
      File exceeds maximum file size: {{\$ctrl.resolvedValidate.size.max}}
  </div>
  <div class="alert alert--danger" ng-if="\$ctrl.uploadForm.\$dirty && (\$ctrl.invalidFiles.\$error === 'pattern' || \$ctrl.invalidFiles[0].\$error === 'pattern')">
      Incorrect file type
  </div>

  <file-upload-webcam ng-if="\$ctrl.webcamVisible"
      class="file-upload-new__modal"
      on-closed="\$ctrl.hideWebcam()"
      on-photo-taken="\$ctrl.onPhotoTaken(blob)"></file-upload-webcam>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/file-upload/file-upload-new.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;